module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-container",
    class: {
      'is-active': _vm.isCollapse
    }
  }, [_c('logo', {
    attrs: {
      "isCollapse": _vm.isCollapse
    }
  }), _vm._v(" "), _c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "unique-opened": "",
      "default-active": _vm.nowTagValue,
      "mode": "vertical",
      "show-timeout": 200,
      "background-color": "#344762",
      "text-color": "hsla(0,0%,100%,1)",
      "active-text-color": "#409eff",
      "collapse": _vm.isCollapse
    }
  }, [_c('sidebar-item', {
    attrs: {
      "menu": _vm.menu,
      "isCollapse": _vm.isCollapse
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7a58f52c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/sidebar/index.vue
// module id = IiL+
// module chunks = 5